import { KeycloakConfig } from "keycloak-js";

const keycloakConfig: KeycloakConfig = {
  url: 'https://maps.vnpost.vn/auth',
  realm: 'vpost',
  clientId: 'vpost-cli'
};

export const environment = {
  production: false,
  keycloakConfig,
  url: 'https://maps.vnpost.vn/',
  urlTemp: '',
  apikey: '4ac5cd369862d1753ff3c6ca6e07b7cff091e03486d32344',
  apikey2:'1aac351f491be75612da6f95323210be44a7ba1a841fe045'
};
